import React from 'react'

type ImageProps = {
  imageUrl: string
}

const QuestionImage = ({ imageUrl }: ImageProps) => (
  <div className="relative rounded-md overflow-hidden bg-gray-50">
    <img src={imageUrl} alt="question visual" loading="lazy" />
  </div>
)

export default QuestionImage
